import React, { useContext, useState } from 'react';
import './productView.css';
import Data from '../../Data';
import CardProducts from '../cardComponent/CardProducts';
import axios from 'axios';
import {
  useParams
} from "react-router-dom";
import LoadingProductView from './LoadingProductView';
import Search from './Search';
import { DataContext } from '../../Context';
import { Modal } from '../../Modal/ReactPortal';

function ProductView({ addToCart }) {
  let { id } = useParams();
  const {openModal, setIdProductView} = useContext(DataContext);

  // console.log("HOLAAAAA")
  // console.log("Este es ID:", id);
  const [card, setCard] = useState([]);
  const [categoria, setCategoria] = useState([]);

  const baseURLProductos = "https://72jjtpdj.directus.app/items/productos?limit=-1";
  const baseURLCategorias = "https://72jjtpdj.directus.app/items/productos_categorias?limit=-1";
  const baseImage = "https://72jjtpdj.directus.app/assets/";
 
  const {inputSearch, setInputSearch, precioValue} = useContext(DataContext);


  React.useEffect(() => {
    axios.get(baseURLProductos).then((response) => {
      setCard(response.data.data);
    });
  }, [])

  React.useEffect(() => {
    axios.get(baseURLCategorias).then((response) => {
      setCategoria(response.data.data.filter(item => Number(item.categorias_id) === Number(id)));
    });
    setIdProductView(id)
  }, [id]);

  return (
    <>
      <Search></Search>
      <div className="motherboard_container">
        {
          card.length === 0 && new Array(8).fill().map((item, index) => (
            <LoadingProductView key={index} />
          ))
        }
        {card && card.sort((a , b) => a.precio - b.precio).map((productItem) => (
          categoria.map((value, index) => {
            if (value.productos_id === productItem.id) {

              if (productItem.nombre.toLowerCase().includes(inputSearch.trim().toLowerCase())) {
                return (
                  <CardProducts 
                    key={index} 
                    stock={productItem.stock} 
                    valueFinal={precioValue * productItem.precio} 
                    id={productItem.id} 
                    productItem={productItem} 
                    addToCart={addToCart} 
                    name={productItem.nombre} 
                    img={productItem.imagen} 
                    price={productItem.precio} 
                    descuento={productItem.descuento} 
                    category={""} 
                  />
                )
              }
            }
          })
        ))
        }
      </div>
    </>
  )
}

export default ProductView